export enum AnnuityValueControlStatus {
  Draft = 0,
  Approved = 1,
  Rejected = 3,
}

export const displayAnnuityValueControlStatus = (
  value: AnnuityValueControlStatus,
) => {
  switch (value) {
    case AnnuityValueControlStatus.Draft:
      return 'Draft';
    case AnnuityValueControlStatus.Rejected:
      return 'Rejected';
    case AnnuityValueControlStatus.Approved:
      return 'Approved';
  }
};
export const displayAnnuityValueControlStatusDecision = (
  value: AnnuityValueControlStatus,
) => {
  switch (value) {
    case AnnuityValueControlStatus.Rejected:
      return 'Reject';
    case AnnuityValueControlStatus.Approved:
      return 'Approve';
  }
};
